import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal, Col, Row } from "antd";
import { useTranslation } from "react-i18next";

interface AddEditModall {
  isOpenNotFound: boolean;
  setIsOpenNotFound: React.Dispatch<React.SetStateAction<boolean>>;
}
const ItemNotFoundModal = ({
  isOpenNotFound,
  setIsOpenNotFound,
}: AddEditModall) => {
  const [t] = useTranslation("common");
  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        onCancel={() => setIsOpenNotFound(false)}
        open={isOpenNotFound}
        centered
        okText={`${t("confirm")}`}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
        }}
        cancelButtonProps={{
          style: {
            display: "none",
          },
        }}
        onOk={() => setIsOpenNotFound(false)}
        title={
          <Row>
            <Col span={3}>
              <ExclamationCircleFilled
                style={{
                  color: "#FFBC39",
                  fontSize: "45px",
                  marginRight: "12px",
                  marginTop: "22px",
                }}
              />
            </Col>
            <Col
              span={19}
              style={{
                fontSize: "32px",
                color: "#212121",
              }}
            >
              {t("item-not-found")}
              <Col
                span={19}
                style={{
                  fontSize: "16px",
                  color: "#212121",
                }}
              >
                {t("please-choose-another-item")}
              </Col>
            </Col>
          </Row>
        }
      />
    </>
  );
};
export default ItemNotFoundModal;
